import React from 'react';

function CircledWSVG() {
    return (
        <div title='Walk-In' className='icon-container'>
            <svg viewBox='0 0 50 50' width='50' height='50'>
                <path d='M25,2C12.297,2,2,12.297,2,25c0,12.703,10.297,23,23,23s23-10.297,23-23C48,12.297,37.703,2,25,2z M31.337,34h-2.121 l-4.141-14.208h-0.15L20.784,34h-2.121l-4.902-18h2.345l3.58,14.632h0.15L23.865,16h2.27l4.029,14.632h0.15L33.894,16h2.345 L31.337,34z'/>
            </svg>
        </div>
    );
}

export default CircledWSVG;
